import PropTypes from 'prop-types';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography, makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  actions: {
    padding: theme.spacing(2, 3, 3),
    gap: theme.spacing(1.5),
  },
}));

// Shared unsaved-changes prompt. Default (company forms): outlined Cancel/Discard, contained Save on the right.
// `pillButtons` is the record full-view variant (lighter text buttons, Save-first order).
function UnsavedChangesDialog({ open, onSave, onDiscard, onCancel, title, description, saving, pillButtons }) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onCancel} aria-labelledby='unsaved-changes-title' aria-describedby='unsaved-changes-description'>
      <DialogTitle id='unsaved-changes-title' disableTypography>
        <Typography variant='h4'>{title || t('components.unsavedChangesDialog.title')}</Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id='unsaved-changes-description'>
          {description || t('components.unsavedChangesDialog.description')}
        </DialogContentText>
      </DialogContent>
      <DialogActions className={pillButtons ? undefined : classes.actions}>
        {pillButtons ? (
          <>
            {onSave && (
              <Button variant='contained' color='primary' onClick={onSave} disabled={saving}>
                {t('commonUsedWords.save')}
              </Button>
            )}
            <Button color='secondary' onClick={onDiscard} disabled={saving}>
              {t('components.unsavedChangesDialog.discardChanges')}
            </Button>
            <Button color='primary' autoFocus onClick={onCancel} disabled={saving}>
              {t('commonUsedWords.cancel')}
            </Button>
          </>
        ) : (
          <>
            <Button variant='outlined' color='primary' onClick={onCancel} disabled={saving}>
              {t('commonUsedWords.cancel')}
            </Button>
            <Button variant='outlined' color='primary' onClick={onDiscard} disabled={saving}>
              {t('components.unsavedChangesDialog.discardChanges')}
            </Button>
            {onSave && (
              <Button variant='contained' color='primary' onClick={onSave} disabled={saving}>
                {t('commonUsedWords.save')}
              </Button>
            )}
          </>
        )}
      </DialogActions>
    </Dialog>
  );
}

UnsavedChangesDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onSave: PropTypes.func,
  onDiscard: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  saving: PropTypes.bool,
  pillButtons: PropTypes.bool,
};

export default UnsavedChangesDialog;
